<div class="ag-chat h-100 w-100 d-flex flex-column">
  <div class="ag-chat-history flex-grow-1" #chatHistory>
    <div
      class="chat-msg w-100 d-flex flex-column"
      *ngFor="let msg of messages; let i = index"
      [ngClass]="{ 'is-sent': msg.isSender }"
    >
      <div *ngIf="msg.files?.length">
        <div class="attachment-wrap" *ngFor="let file of msg.files">
          <img [src]="'images/virtusa-icons/file.png' | assetUrl" alt="attachment" />
          <span> {{ file.name }} </span>
        </div>
      </div>

      <!-- Human messages are rendered as plain text to prevent XSS/HTML-injection. -->
      <span
        [hidden]="msg?.role !== 'human'"
        class="msg-renderer render-color-human human-text"
      >{{ msg.content }}</span>

      <!-- AI Message with potential card -->
      <ng-container *ngIf="msg?.role === 'ai'">
        <!-- Content before card (if card exists) or full content (if no card) -->
        <span
          *ngIf="!hasCardMarker(msg)"
          class="msg-renderer w-100"
          [innerHTML]="msg.content"
          (click)="handleInlineSuggestionClick($event)"
          (keydown)="handleInlineSuggestionClick($event)"
        >
        </span>

        <!-- If message has card marker, split and render properly -->
        <ng-container *ngIf="hasCardMarker(msg)">
          <span
            class="msg-renderer w-100"
            [innerHTML]="parseCardContent(msg).beforeCard"
            (click)="handleInlineSuggestionClick($event)"
            (keydown)="handleInlineSuggestionClick($event)"
          >
          </span>

          <!-- Dynamic Card Renderer - Works for ALL card types -->
          <ng-container *ngIf="getCardConfig(parseCardContent(msg).cardType) as cardConfig">
            <div class="create-application-card">
              <div class="card-header">
                <h3>{{ cardConfig.title }}</h3>
                <p>{{ cardConfig.description }}</p>
              </div>
              <div class="card-body">
                <button class="btn-create-now" (click)="onCardSubmit(parseCardContent(msg).cardType, msg?.metadata)">
                  {{ cardConfig.buttonText }}
                </button>
              </div>
            </div>
          </ng-container>

          <span
            class="msg-renderer w-100"
            [innerHTML]="parseCardContent(msg).afterCard"
            (click)="handleInlineSuggestionClick($event)"
            (keydown)="handleInlineSuggestionClick($event)"
          >
          </span>
        </ng-container>
      </ng-container>

      <div [hidden]="msg?.role !== 'ai'" class="copy-div">
        <img
          *ngIf="shouldShowCopy(msg, i)"
          [src]="'images/virtusa-icons/copy-dark.svg' | assetUrl"
          class="copy-icon"
          (click)="copyMsg(msg.content)"
          (keydown.enter)="copyMsg(msg.content)"
          alt="copy"
        />
      </div>
      <!-- ── THINKING state: before first tool_call arrives ─────────────── -->
      <div *ngIf="msg.isProcessing && msg.isThinking" class="processing thinking-state d-flex align-items-center">
        <div class="mat-spinner-wrap">
          <mat-spinner class="w-100 h-100"></mat-spinner>
        </div>
        <span class="thinking-label">Thinking...</span>
      </div>

      <!-- ── STREAMING WORKFLOW: tool_calls arriving ──────────────────── -->
      <div *ngIf="msg.isProcessing && !msg.isThinking && msg.workflowSteps?.length" class="workflow-block">
        <button type="button" class="workflow-header" (click)="toggleWorkflow(msg)">
          <div class="mat-spinner-wrap">
            <mat-spinner class="w-100 h-100"></mat-spinner>
          </div>
          <span class="workflow-title">Agent Working...</span>
          <i class="bi" [ngClass]="msg.workflowExpanded ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
        </button>
        <div class="workflow-steps" *ngIf="msg.workflowExpanded">
          <div class="workflow-step" *ngFor="let step of msg.workflowSteps">
            <img
              *ngIf="step.icon"
              class="workflow-step-icon"
              [src]="('images/virtusa-icons/agent/' + step.icon + '.svg') | assetUrl"
              [alt]="step.icon"
            />
            {{ step.message }}
          </div>
        </div>
      </div>

      <!-- ── COMPLETED WORKFLOW: collapsed by default, user can expand ── -->
      <div *ngIf="!msg.isProcessing && msg.workflowSteps?.length" class="workflow-block workflow-block--done">
        <button type="button" class="workflow-header workflow-header--done" (click)="toggleWorkflow(msg)">
          <span class="workflow-title">Agent Workflow</span>
          <i class="bi" [ngClass]="msg.workflowExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
        </button>
        <div class="workflow-steps" *ngIf="msg.workflowExpanded">
          <div class="workflow-step" *ngFor="let step of msg.workflowSteps">
            <img
              *ngIf="step.icon"
              class="workflow-step-icon"
              [src]="('images/virtusa-icons/agent/' + step.icon + '.svg') | assetUrl"
              [alt]="step.icon"
            />
            {{ step.message }}
          </div>
        </div>
      </div>

      <div
        *ngIf="
          msg?.status === 'completed' &&
          msg?.tool_data?.result &&
          msg?.tool_data?.result[0]?.data &&
          msg?.tool_data?.result[0]?.type !== 'script_execution_started' &&
          msg?.tool_data?.result[0]?.type !== 'progress_bar'
        "
        class="completion-box"
      >
        <div
          class="d-flex flex-column align-items-start justify-content-around w-100 m-2"
        >
          <div class="d-flex align-items-end mt-2">
            <div class="flex-grow-1 light-text"></div>
            <button class="btn-chat-complete">
              <img
                [src]="'images/virtusa-icons/pass-check.svg' | assetUrl"
                alt="check"
                width="12"
                height="12"
              />
              <span class="accello-general-text12">
                {{
                  msg?.tool_data?.result[0]?.data.isCancelled
                    ? "Cancelled"
                    : "Completed"
                }}</span
              >
            </button>
          </div>
          <div class="d-flex w-100">
            <span class="completion-msg text-truncate d-block">
              {{ msg?.tool_data?.message }}
            </span>
          </div>
          <div class="action-btn">
            <button
              type="button"
              *ngIf="msg?.tool_data?.isDownload"
              (click)="downloadExcel(msg)"
            >
              <img [src]="'images/virtusa-icons/chat-download-purple.svg' | assetUrl" alt="download" />
              Download
            </button>

            <button
              [hidden]="
                msg?.tool_data?.result[0]?.data.isCancelled ||
                msg?.tool_data?.result[0]?.type === 'progress_bar'
              "
              type="button"
              (click)="openHistoryView(msg)"
            >
              <img
                [src]="'images/virtusa-icons/new-tab-purple.svg' | assetUrl" alt="preview"
              />Preview
            </button>
          </div>
        </div>
      </div>

      <div
       *ngIf="msg?.status === 'error' && msg?.message"
        class="error-box"
      >
        <div
          class="d-flex flex-column align-items-start justify-content-around w-100 m-2"
        >
          <div class="d-flex align-items-end mt-2">
            <div class="flex-grow-1 light-text"></div>
            <button class="btn-chat-error">
              <img
                [src]="'images/virtusa-icons/warning.svg' | assetUrl"
                alt="check"
                width="12"
                height="12"
              />
              <span class="accello-general-text12"> Error</span>
            </button>
          </div>
          <div class="d-flex w-100">
            <span class="error-msg text-truncate d-block">
              {{
                msg?.message && msg?.message !== "undefined"
                  ? msg?.message
                  : "An error occurred while processing your request. Please try again."
              }}
            </span>
          </div>
          <div class="action-btn">
            <button type="button" (click)="tryAgain()">
              <img [src]="'images/virtusa-icons/refresh-purple.svg' | assetUrl" alt="Try again" />Try
              again
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="ag-send-wrapper p-3 d-flex flex-column justify-content-end">
    <div class="info-prompt"></div>
    <div class="txt-wrapper" [ngClass]="{ 'disable-area': isInputDisabled }">
      <div class="d-flex attachments-list overflow-auto mt-2 mx-2" [hidden]="!attachments.length && !selectedRows.length">
        <div
          *ngFor="let attachment of attachments; let i = index"
          class="attachment-item d-flex"
        >
          <img
            *ngIf="isImage(attachment)"
            [src]="attachment.imageUrl"
            [alt]="attachment.name"
          />
          <img
            *ngIf="!isImage(attachment)"
            [src]="'images/virtusa-icons/file.png' | assetUrl"
            [alt]="attachment.name"
          />
          <span class="text-truncate"> {{ attachment.name }} </span>
          <img
            class="att-remove"
            [src]="'images/virtusa-icons/close.png' | assetUrl"
            alt="remove"
            (click)="removeAttachment(i)"
            (keydown.enter)="removeAttachment(i)"
          />
        </div>
        <div *ngIf="selectedRows.length" class="d-flex overflow-auto mt-2 mx-2">
          <div *ngFor="let chip of selectedRows" class="chip-item">
            {{ chip.chipName }}
          </div>
        </div>
      </div>
      <textarea
        type="text"
        [disabled]="isInputDisabled"
        [(ngModel)]="sendInput"
        id="sendTxtArea"
        placeholder="Ask a question or make a request..."
        (keydown.enter)="send()"
      ></textarea>
      <div class="send-actions d-flex mb-2">
        <div
          class="accello-icon-btn"
          (mousedown)="isActive = true"
          (mouseup)="isActive = false"
          (mouseleave)="isActive = false"
          (click)="triggerFileInput()"
          (keydown)="triggerFileInput()"
          [hidden]="selectedRows?.length"
        >
          <img
            [src]="
              (isActive
                ? 'images/virtusa-icons/add-attachments.svg'
                : 'images/virtusa-icons/add-attachments-light.svg') | assetUrl
            " alt="attachment"
          />
        </div>
      <!-- <img [src]="'images/virtusa-icons/agentic-plus.png' | assetUrl" alt="plus" (click)="triggerFileInput()" [hidden]="selectedRows?.length"> -->
        <span
          [matTooltip]="isSendDisabledByAttachment ? 'Ask a question or make a\nrequest before sending' : ''"
          matTooltipPosition="above"
          matTooltipClass="prompt-ui-tooltip"
        >
          <img
            [src]="'images/virtusa-icons/agentic-send.svg' | assetUrl"
            alt="send"
            [class.send-disabled]="isSendDisabledByAttachment"
            (click)="send()"
            (keydown)="send()"
          />
        </span>
      </div>
    </div>
  </div>
</div>

<!-- hidden file input -->
<input
  type="file"
  #fileInput
  style="display: none"
  (change)="onFileSelected($event)"
/>
